import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import EnclosedOlcaLogo from './EnclosedOlcaLogo';

type Props = {
    title: string
};


export default function FormHeader(props: Props) {

    return (
        <Box>
            <EnclosedOlcaLogo></EnclosedOlcaLogo>
            <p className="formTitle">{props.title}</p>
            <Divider sx={{margin: '17px 6% 20px', display: 'block', background: '#008F39'}} variant="middle" />
        </Box>
    );
}